'use client';
import { LabelFilter } from '@/app/components/shared/LabelFilter';
import { useExtraTag } from '@/app/hooks';
import type { TagType } from '@/app/types';
import { cn, reportEvent } from '@/app/utils';

export const PostReferenceFilter = ({
  className,
  categories,
  activeCategory,
  setActiveCategory,
  size,
  children,
}: {
  className?: string;
  categories?: TagType[];
  activeCategory?: string;
  setActiveCategory: (data: string) => void;
  size?: 'small' | 'default';
  children?: React.ReactNode;
}) => {
  const { allTag } = useExtraTag();

  return (
    <div className={cn('flex items-center justify-between gap-2 sm:gap-1', className)}>
      <LabelFilter
        tags={categories || []}
        selectedTags={activeCategory ? [activeCategory] : []}
        onTagSelect={(val, name) => {
          reportEvent('reference_type_click', {
            type_name: name || '',
          });
          setActiveCategory(val === activeCategory || !val ? allTag.id : val);
        }}
        className="flex-1 overflow-hidden"
        size={size}
      />
      {children}
    </div>
  );
};
